module.exports = __webpack_public_path__ + "assets/icons/textsms-24px.svg";